module.exports = __webpack_public_path__ + "static/media/further_english_logo.762dd7eb.png";